<template>
  <v-container class="container--max ch-section" tag="section" v-if="featuredPost">
    <v-row>
      <v-col cols="12">
        <div class="ch-section__titleX accent--text">
          <v-btn text color="accent" href="/columnists">Columnists <v-icon small right>mdi-chevron-right</v-icon></v-btn>
          <v-btn text color="accent" href="/comment">Comment <v-icon small right>mdi-chevron-right</v-icon></v-btn>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <v-card class="ch-post ch-post--featured" :href="featuredPost.link" flat>
          <v-img :src="featuredPost.image ? featuredPost.image : featuredPost.author_image" :aspect-ratio="16/9" cover class="grey lighten-4"></v-img>
          <v-card-title v-html="featuredPost.title" class="ch-post__title font-weight-bold text--caslon"></v-card-title>
          <v-card-subtitle class="primary--text py-1 d-flex">
            <span v-if="featuredPost.category.name == 'Sponsored'" class="accent--text">Sponsored</span>
            <span v-else v-html="featuredPost.author_name"></span>
<!--             <v-spacer></v-spacer>
            <span v-if="commentCounts[featuredPost.id] > 0" class="accent--text caption">
              <v-icon small color="accent">mdi-comment-multiple</v-icon> {{ commentCounts[featuredPost.id] }}
            </span> -->
          </v-card-subtitle>
          <v-card-text v-html="featuredPost.excerpt"></v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" class="mt-n4">
        <v-card class="mb-2 ch-post ch-post--secondary" v-for="(item, i) in otherItems" :key="i" :href="item.link" flat>
          <v-card-title v-html="item.title" class="ch-post__title ch-post__subtitle text--caslon"></v-card-title>
          <v-card-subtitle class="primary--text py-2 d-flex">
            <span v-if="item.category.name == 'Sponsored'" class="accent--text">Sponsored</span>
            <span v-else v-html="item.author_name"></span>
<!--             <v-spacer></v-spacer>
            <span v-if="commentCounts[item.id] > 0" class="accent--text caption">
              <v-icon small color="accent">mdi-comment-multiple</v-icon> {{ commentCounts[item.id] }}
            </span> -->
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
  export default {
    name: 'HomeComment',

    mixins: [
      require('./section.js').default
    ],

    methods: {
      getCommentPosts() {
        this.$axios.get('/wp-json/wp/v2/posts?exclude=' + this.excludedIds
          + '&categories=' + this.categories
          + '&filter[orderby]=date&order=desc&per_page=5')
        .then(response => {
          this.items = response.data
        }).then(() => {
          // this.getPostCommentCounts()
        })
      },
      // getPostCommentCounts() {
      //   this.$axios.get('https://api.vuukle.com/api/v1/Comments/getCommentCountListByHost?host=conservativehome.com&articleIds=' + this.itemIds.join())
      //   .then(response => {
      //     this.commentCounts = response.data.data
      //     console.log(response.data)
      //   }).catch(error => {
      //     console.log(error.message)
      //   })
      // }
    },

    mounted() {
      this.getCommentPosts()
    }
  }
</script>